export type LocationType = "bundesland" | "stadt" | "wien-bezirk";

export type Location = {
  slug: string;
  name: string; // Anzeigename ohne Zusatz
  type: LocationType;
  bundesland: string; // Anzeigename, z.B. "Niederösterreich"
  bundeslandSlug: string;
  plz?: string; // 1 oder mehrere PLZ
  population?: number;
  region?: string; // grobe Region/Bezirk
};

// Bundesländer (9)
export const bundeslaender: Location[] = [
  { slug: "wien", name: "Wien", type: "bundesland", bundesland: "Wien", bundeslandSlug: "wien", plz: "1010–1230", population: 2_005_000 },
  { slug: "niederoesterreich", name: "Niederösterreich", type: "bundesland", bundesland: "Niederösterreich", bundeslandSlug: "niederoesterreich", population: 1_720_000 },
  { slug: "oberoesterreich", name: "Oberösterreich", type: "bundesland", bundesland: "Oberösterreich", bundeslandSlug: "oberoesterreich", population: 1_530_000 },
  { slug: "steiermark", name: "Steiermark", type: "bundesland", bundesland: "Steiermark", bundeslandSlug: "steiermark", population: 1_260_000 },
  { slug: "tirol", name: "Tirol", type: "bundesland", bundesland: "Tirol", bundeslandSlug: "tirol", population: 770_000 },
  { slug: "kaernten", name: "Kärnten", type: "bundesland", bundesland: "Kärnten", bundeslandSlug: "kaernten", population: 565_000 },
  { slug: "salzburg-land", name: "Salzburg (Land)", type: "bundesland", bundesland: "Salzburg", bundeslandSlug: "salzburg-land", population: 565_000 },
  { slug: "vorarlberg", name: "Vorarlberg", type: "bundesland", bundesland: "Vorarlberg", bundeslandSlug: "vorarlberg", population: 405_000 },
  { slug: "burgenland", name: "Burgenland", type: "bundesland", bundesland: "Burgenland", bundeslandSlug: "burgenland", population: 300_000 },
];

// 23 Wiener Gemeindebezirke
export const wienBezirke: Location[] = [
  { slug: "wien-1-innere-stadt", name: "Wien 1. Bezirk – Innere Stadt", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1010", population: 16_400 },
  { slug: "wien-2-leopoldstadt", name: "Wien 2. Bezirk – Leopoldstadt", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1020", population: 109_000 },
  { slug: "wien-3-landstrasse", name: "Wien 3. Bezirk – Landstraße", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1030", population: 95_000 },
  { slug: "wien-4-wieden", name: "Wien 4. Bezirk – Wieden", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1040", population: 33_000 },
  { slug: "wien-5-margareten", name: "Wien 5. Bezirk – Margareten", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1050", population: 56_000 },
  { slug: "wien-6-mariahilf", name: "Wien 6. Bezirk – Mariahilf", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1060", population: 31_000 },
  { slug: "wien-7-neubau", name: "Wien 7. Bezirk – Neubau", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1070", population: 32_000 },
  { slug: "wien-8-josefstadt", name: "Wien 8. Bezirk – Josefstadt", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1080", population: 25_000 },
  { slug: "wien-9-alsergrund", name: "Wien 9. Bezirk – Alsergrund", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1090", population: 42_000 },
  { slug: "wien-10-favoriten", name: "Wien 10. Bezirk – Favoriten", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1100", population: 213_000 },
  { slug: "wien-11-simmering", name: "Wien 11. Bezirk – Simmering", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1110", population: 109_000 },
  { slug: "wien-12-meidling", name: "Wien 12. Bezirk – Meidling", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1120", population: 100_000 },
  { slug: "wien-13-hietzing", name: "Wien 13. Bezirk – Hietzing", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1130", population: 56_000 },
  { slug: "wien-14-penzing", name: "Wien 14. Bezirk – Penzing", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1140", population: 99_000 },
  { slug: "wien-15-rudolfsheim-fuenfhaus", name: "Wien 15. Bezirk – Rudolfsheim-Fünfhaus", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1150", population: 81_000 },
  { slug: "wien-16-ottakring", name: "Wien 16. Bezirk – Ottakring", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1160", population: 105_000 },
  { slug: "wien-17-hernals", name: "Wien 17. Bezirk – Hernals", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1170", population: 57_000 },
  { slug: "wien-18-waehring", name: "Wien 18. Bezirk – Währing", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1180", population: 51_000 },
  { slug: "wien-19-doebling", name: "Wien 19. Bezirk – Döbling", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1190", population: 73_000 },
  { slug: "wien-20-brigittenau", name: "Wien 20. Bezirk – Brigittenau", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1200", population: 86_000 },
  { slug: "wien-21-floridsdorf", name: "Wien 21. Bezirk – Floridsdorf", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1210", population: 167_000 },
  { slug: "wien-22-donaustadt", name: "Wien 22. Bezirk – Donaustadt", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1220", population: 200_000 },
  { slug: "wien-23-liesing", name: "Wien 23. Bezirk – Liesing", type: "wien-bezirk", bundesland: "Wien", bundeslandSlug: "wien", plz: "1230", population: 105_000 },
];

// Städte / Gemeinden – fokus auf realistisches Einzugsgebiet
// Format: [slug, name, bundeslandSlug, plz, pop, region]
type C = [string, string, string, string, number, string];
const compact: C[] = [
  // ===== Niederösterreich – Industrieviertel & Wien-Umgebung =====
  ["st-poelten", "St. Pölten", "niederoesterreich", "3100", 56_000, "Landeshauptstadt"],
  ["wiener-neustadt", "Wiener Neustadt", "niederoesterreich", "2700", 48_000, "Industrieviertel"],
  ["klosterneuburg", "Klosterneuburg", "niederoesterreich", "3400", 27_500, "Wienerwald"],
  ["baden", "Baden", "niederoesterreich", "2500", 26_400, "Industrieviertel"],
  ["krems-an-der-donau", "Krems an der Donau", "niederoesterreich", "3500", 24_900, "Wachau"],
  ["amstetten", "Amstetten", "niederoesterreich", "3300", 23_700, "Mostviertel"],
  ["moedling", "Mödling", "niederoesterreich", "2340", 21_000, "Industrieviertel"],
  ["tulln", "Tulln an der Donau", "niederoesterreich", "3430", 16_900, "Tullnerfeld"],
  ["neunkirchen", "Neunkirchen", "niederoesterreich", "2620", 13_300, "Industrieviertel"],
  ["schwechat", "Schwechat", "niederoesterreich", "2320", 19_700, "Industrieviertel"],
  ["stockerau", "Stockerau", "niederoesterreich", "2000", 16_900, "Weinviertel"],
  ["traiskirchen", "Traiskirchen", "niederoesterreich", "2514", 19_700, "Industrieviertel"],
  ["brunn-am-gebirge", "Brunn am Gebirge", "niederoesterreich", "2345", 13_400, "Industrieviertel"],
  ["perchtoldsdorf", "Perchtoldsdorf", "niederoesterreich", "2380", 15_500, "Industrieviertel"],
  ["bad-voeslau", "Bad Vöslau", "niederoesterreich", "2540", 12_500, "Industrieviertel"],
  ["korneuburg", "Korneuburg", "niederoesterreich", "2100", 13_900, "Weinviertel"],
  ["gerasdorf", "Gerasdorf bei Wien", "niederoesterreich", "2201", 11_700, "Weinviertel"],
  ["hollabrunn", "Hollabrunn", "niederoesterreich", "2020", 12_000, "Weinviertel"],
  ["gaenserndorf", "Gänserndorf", "niederoesterreich", "2230", 12_000, "Weinviertel"],
  ["mistelbach", "Mistelbach", "niederoesterreich", "2130", 11_700, "Weinviertel"],
  ["zwettl", "Zwettl", "niederoesterreich", "3910", 10_700, "Waldviertel"],
  ["waidhofen-an-der-ybbs", "Waidhofen an der Ybbs", "niederoesterreich", "3340", 11_300, "Mostviertel"],
  ["horn", "Horn", "niederoesterreich", "3580", 6_500, "Waldviertel"],
  ["wolkersdorf", "Wolkersdorf im Weinviertel", "niederoesterreich", "2120", 8_300, "Weinviertel"],
  ["purkersdorf", "Purkersdorf", "niederoesterreich", "3002", 10_500, "Wienerwald"],
  ["berndorf", "Berndorf", "niederoesterreich", "2560", 9_100, "Industrieviertel"],
  ["melk", "Melk", "niederoesterreich", "3390", 5_300, "Mostviertel"],
  ["ternitz", "Ternitz", "niederoesterreich", "2630", 14_800, "Industrieviertel"],
  ["maria-enzersdorf", "Maria Enzersdorf", "niederoesterreich", "2344", 9_700, "Industrieviertel"],
  ["voesendorf", "Vösendorf", "niederoesterreich", "2331", 8_300, "Industrieviertel"],
  ["guntramsdorf", "Guntramsdorf", "niederoesterreich", "2353", 10_500, "Industrieviertel"],
  ["ebreichsdorf", "Ebreichsdorf", "niederoesterreich", "2483", 11_700, "Industrieviertel"],
  ["bruck-an-der-leitha", "Bruck an der Leitha", "niederoesterreich", "2460", 8_300, "Industrieviertel"],
  ["hainburg", "Hainburg an der Donau", "niederoesterreich", "2410", 6_500, "Industrieviertel"],
  ["gross-enzersdorf", "Groß-Enzersdorf", "niederoesterreich", "2301", 11_000, "Marchfeld"],
  ["deutsch-wagram", "Deutsch-Wagram", "niederoesterreich", "2232", 9_300, "Marchfeld"],
  ["strasshof", "Strasshof an der Nordbahn", "niederoesterreich", "2231", 11_400, "Marchfeld"],
  ["neulengbach", "Neulengbach", "niederoesterreich", "3040", 8_900, "Wienerwald"],
  ["pressbaum", "Pressbaum", "niederoesterreich", "3021", 7_900, "Wienerwald"],
  ["himberg", "Himberg", "niederoesterreich", "2325", 6_900, "Industrieviertel"],
  ["langenzersdorf", "Langenzersdorf", "niederoesterreich", "2103", 8_400, "Weinviertel"],
  ["leobendorf", "Leobendorf", "niederoesterreich", "2100", 5_300, "Weinviertel"],

  // NÖ Erweiterung: Industrieviertel rund um Mödling/Baden/WN
  ["wiener-neudorf", "Wiener Neudorf", "niederoesterreich", "2351", 10_500, "Industrieviertel"],
  ["hennersdorf", "Hennersdorf", "niederoesterreich", "2332", 2_300, "Industrieviertel"],
  ["biedermannsdorf", "Biedermannsdorf", "niederoesterreich", "2362", 3_200, "Industrieviertel"],
  ["laxenburg", "Laxenburg", "niederoesterreich", "2361", 3_000, "Industrieviertel"],
  ["muenchendorf", "Münchendorf", "niederoesterreich", "2482", 3_600, "Industrieviertel"],
  ["gumpoldskirchen", "Gumpoldskirchen", "niederoesterreich", "2352", 3_800, "Industrieviertel"],
  ["pfaffstaetten", "Pfaffstätten", "niederoesterreich", "2511", 3_600, "Industrieviertel"],
  ["sooss", "Sooß", "niederoesterreich", "2500", 800, "Industrieviertel"],
  ["leobersdorf", "Leobersdorf", "niederoesterreich", "2544", 5_300, "Industrieviertel"],
  ["hirtenberg", "Hirtenberg", "niederoesterreich", "2552", 2_400, "Industrieviertel"],
  ["pottenstein", "Pottenstein", "niederoesterreich", "2563", 2_700, "Industrieviertel"],
  ["sollenau", "Sollenau", "niederoesterreich", "2601", 4_500, "Industrieviertel"],
  ["felixdorf", "Felixdorf", "niederoesterreich", "2603", 4_400, "Industrieviertel"],
  ["theresienfeld", "Theresienfeld", "niederoesterreich", "2604", 2_400, "Industrieviertel"],
  ["woellersdorf", "Wöllersdorf-Steinabrückl", "niederoesterreich", "2752", 4_800, "Industrieviertel"],
  ["bad-fischau", "Bad Fischau-Brunn", "niederoesterreich", "2721", 3_400, "Industrieviertel"],
  ["bad-erlach", "Bad Erlach", "niederoesterreich", "2822", 2_900, "Industrieviertel"],
  ["lichtenwoerth", "Lichtenwörth", "niederoesterreich", "2493", 2_600, "Industrieviertel"],
  ["eggendorf", "Eggendorf", "niederoesterreich", "2700", 2_900, "Industrieviertel"],
  ["winzendorf", "Winzendorf-Muthmannsdorf", "niederoesterreich", "2731", 2_000, "Industrieviertel"],
  ["wuerflach", "Würflach", "niederoesterreich", "2732", 2_300, "Industrieviertel"],
  ["gloggnitz", "Gloggnitz", "niederoesterreich", "2640", 5_900, "Industrieviertel"],
  ["reichenau", "Reichenau an der Rax", "niederoesterreich", "2651", 2_500, "Industrieviertel"],
  ["puchberg", "Puchberg am Schneeberg", "niederoesterreich", "2734", 2_700, "Industrieviertel"],
  ["pottschach", "Pottschach", "niederoesterreich", "2630", 1_600, "Industrieviertel"],
  ["enzesfeld-lindabrunn", "Enzesfeld-Lindabrunn", "niederoesterreich", "2551", 4_500, "Industrieviertel"],
  ["traisen", "Traisen", "niederoesterreich", "3160", 3_100, "Mostviertel"],

  // NÖ Marchfeld & Weinviertel
  ["markgrafneusiedl", "Markgrafneusiedl", "niederoesterreich", "2293", 1_500, "Marchfeld"],
  ["untersiebenbrunn", "Untersiebenbrunn", "niederoesterreich", "2284", 2_200, "Marchfeld"],
  ["engelhartstetten", "Engelhartstetten", "niederoesterreich", "2292", 1_800, "Marchfeld"],
  ["lassee", "Lassee", "niederoesterreich", "2291", 2_400, "Marchfeld"],
  ["marchegg", "Marchegg", "niederoesterreich", "2294", 3_000, "Marchfeld"],
  ["orth-an-der-donau", "Orth an der Donau", "niederoesterreich", "2304", 2_300, "Marchfeld"],
  ["schoenkirchen-reyersdorf", "Schönkirchen-Reyersdorf", "niederoesterreich", "2241", 4_100, "Weinviertel"],
  ["matzen-raggendorf", "Matzen-Raggendorf", "niederoesterreich", "2243", 2_500, "Weinviertel"],
  ["zistersdorf", "Zistersdorf", "niederoesterreich", "2225", 5_500, "Weinviertel"],
  ["poysdorf", "Poysdorf", "niederoesterreich", "2170", 5_500, "Weinviertel"],
  ["laa-an-der-thaya", "Laa an der Thaya", "niederoesterreich", "2136", 6_500, "Weinviertel"],
  ["pillichsdorf", "Pillichsdorf", "niederoesterreich", "2211", 1_700, "Weinviertel"],
  ["grossebersdorf", "Großebersdorf", "niederoesterreich", "2203", 2_900, "Weinviertel"],
  ["spillern", "Spillern", "niederoesterreich", "2104", 2_200, "Weinviertel"],
  ["bisamberg", "Bisamberg", "niederoesterreich", "2102", 3_000, "Weinviertel"],
  ["hagenbrunn", "Hagenbrunn", "niederoesterreich", "2102", 2_100, "Weinviertel"],
  ["enzersfeld", "Enzersfeld im Weinviertel", "niederoesterreich", "2202", 1_900, "Weinviertel"],
  ["wolfpassing", "Wolfpassing", "niederoesterreich", "3261", 1_300, "Mostviertel"],

  // NÖ Wienerwald, Bezirk Wien-Umgebung-West, St. Pölten-Umland
  ["mauerbach", "Mauerbach", "niederoesterreich", "3001", 4_400, "Wienerwald"],
  ["tullnerbach", "Tullnerbach", "niederoesterreich", "3013", 2_300, "Wienerwald"],
  ["wolfsgraben", "Wolfsgraben", "niederoesterreich", "3012", 2_000, "Wienerwald"],
  ["eichgraben", "Eichgraben", "niederoesterreich", "3032", 4_400, "Wienerwald"],
  ["altlengbach", "Altlengbach", "niederoesterreich", "3033", 4_000, "Wienerwald"],
  ["asperhofen", "Asperhofen", "niederoesterreich", "3041", 3_000, "Wienerwald"],
  ["pyhra", "Pyhra", "niederoesterreich", "3143", 3_000, "Mostviertel"],
  ["wilhelmsburg", "Wilhelmsburg", "niederoesterreich", "3150", 6_700, "Mostviertel"],
  ["boeheimkirchen", "Böheimkirchen", "niederoesterreich", "3071", 4_700, "Mostviertel"],
  ["herzogenburg", "Herzogenburg", "niederoesterreich", "3130", 8_300, "Mostviertel"],
  ["hafnerbach", "Hafnerbach", "niederoesterreich", "3386", 1_300, "Mostviertel"],
  ["karlstetten", "Karlstetten", "niederoesterreich", "3121", 1_700, "Mostviertel"],
  ["statzendorf", "Statzendorf", "niederoesterreich", "3125", 1_600, "Mostviertel"],
  ["ober-grafendorf", "Ober-Grafendorf", "niederoesterreich", "3200", 5_000, "Mostviertel"],

  // Wachau / Krems-Umland
  ["spitz", "Spitz", "niederoesterreich", "3620", 1_700, "Wachau"],
  ["duernstein", "Dürnstein", "niederoesterreich", "3601", 800, "Wachau"],
  ["weissenkirchen", "Weißenkirchen in der Wachau", "niederoesterreich", "3610", 1_400, "Wachau"],
  ["mautern", "Mautern an der Donau", "niederoesterreich", "3512", 3_400, "Wachau"],
  ["langenlois", "Langenlois", "niederoesterreich", "3550", 7_500, "Kamptal"],
  ["lengenfeld", "Lengenfeld", "niederoesterreich", "3552", 1_700, "Kamptal"],
  ["gfoehl", "Gföhl", "niederoesterreich", "3542", 3_900, "Waldviertel"],
  ["strass-im-strassertale", "Straß im Straßertale", "niederoesterreich", "3491", 1_500, "Kamptal"],
  ["rohrendorf", "Rohrendorf bei Krems", "niederoesterreich", "3495", 1_700, "Kamptal"],

  // Mostviertel
  ["scheibbs", "Scheibbs", "niederoesterreich", "3270", 4_300, "Mostviertel"],
  ["wieselburg", "Wieselburg", "niederoesterreich", "3250", 4_000, "Mostviertel"],
  ["purgstall", "Purgstall an der Erlauf", "niederoesterreich", "3251", 5_400, "Mostviertel"],
  ["gaming", "Gaming", "niederoesterreich", "3292", 3_100, "Mostviertel"],
  ["lunz", "Lunz am See", "niederoesterreich", "3293", 1_800, "Mostviertel"],
  ["ybbs", "Ybbs an der Donau", "niederoesterreich", "3370", 5_700, "Mostviertel"],
  ["pochlarn", "Pöchlarn", "niederoesterreich", "3380", 3_700, "Mostviertel"],
  ["persenbeug", "Persenbeug-Gottsdorf", "niederoesterreich", "3680", 2_200, "Mostviertel"],
  ["mank", "Mank", "niederoesterreich", "3240", 3_100, "Mostviertel"],
  ["haag", "Haag", "niederoesterreich", "3350", 5_800, "Mostviertel"],

  // Waldviertel
  ["allentsteig", "Allentsteig", "niederoesterreich", "3804", 1_800, "Waldviertel"],
  ["gmuend-noe", "Gmünd (NÖ)", "niederoesterreich", "3950", 5_500, "Waldviertel"],
  ["heidenreichstein", "Heidenreichstein", "niederoesterreich", "3860", 3_900, "Waldviertel"],
  ["schrems", "Schrems", "niederoesterreich", "3943", 5_200, "Waldviertel"],
  ["litschau", "Litschau", "niederoesterreich", "3874", 2_200, "Waldviertel"],
  ["waidhofen-an-der-thaya", "Waidhofen an der Thaya", "niederoesterreich", "3830", 5_500, "Waldviertel"],
  ["raabs-an-der-thaya", "Raabs an der Thaya", "niederoesterreich", "3820", 2_500, "Waldviertel"],
  ["drosendorf", "Drosendorf-Zissersdorf", "niederoesterreich", "2095", 1_100, "Waldviertel"],
  ["geras", "Geras", "niederoesterreich", "2093", 1_300, "Waldviertel"],
  ["pulkau", "Pulkau", "niederoesterreich", "3741", 1_500, "Weinviertel"],
  ["eggenburg", "Eggenburg", "niederoesterreich", "3730", 3_700, "Waldviertel"],
  ["weitra", "Weitra", "niederoesterreich", "3970", 2_600, "Waldviertel"],
  ["arbesbach", "Arbesbach", "niederoesterreich", "3925", 1_700, "Waldviertel"],

  // Lilienfeld / Mariazellerland
  ["lilienfeld", "Lilienfeld", "niederoesterreich", "3180", 2_700, "Voralpen"],
  ["hainfeld", "Hainfeld", "niederoesterreich", "3170", 3_800, "Voralpen"],
  ["tuernitz", "Türnitz", "niederoesterreich", "3184", 1_700, "Voralpen"],
  ["annaberg", "Annaberg", "niederoesterreich", "3222", 600, "Voralpen"],
  ["sankt-aegyd", "Sankt Aegyd am Neuwalde", "niederoesterreich", "3193", 1_900, "Voralpen"],

  // Wachstumsorte Bruck-Schwechat Achse, Marchfeld-Süd
  ["fischamend", "Fischamend", "niederoesterreich", "2401", 5_400, "Industrieviertel"],
  ["maria-lanzendorf", "Maria-Lanzendorf", "niederoesterreich", "2326", 2_200, "Industrieviertel"],
  ["lanzendorf", "Lanzendorf", "niederoesterreich", "2326", 2_100, "Industrieviertel"],
  ["leopoldsdorf", "Leopoldsdorf", "niederoesterreich", "2333", 3_400, "Industrieviertel"],
  ["trumau", "Trumau", "niederoesterreich", "2521", 3_500, "Industrieviertel"],
  ["oberwaltersdorf", "Oberwaltersdorf", "niederoesterreich", "2522", 4_500, "Industrieviertel"],
  ["tribuswinkel", "Tribuswinkel", "niederoesterreich", "2514", 4_000, "Industrieviertel"],
  ["pottendorf", "Pottendorf", "niederoesterreich", "2486", 6_900, "Industrieviertel"],
  ["mannersdorf", "Mannersdorf am Leithagebirge", "niederoesterreich", "2452", 4_300, "Industrieviertel"],
  ["trautmannsdorf", "Trautmannsdorf an der Leitha", "niederoesterreich", "2454", 2_300, "Industrieviertel"],
  ["sommerein", "Sommerein", "niederoesterreich", "2453", 1_900, "Industrieviertel"],
  ["hoeflein", "Höflein", "niederoesterreich", "2465", 1_400, "Industrieviertel"],
  ["goetzendorf", "Götzendorf an der Leitha", "niederoesterreich", "2434", 1_700, "Industrieviertel"],
  ["petronell-carnuntum", "Petronell-Carnuntum", "niederoesterreich", "2404", 1_300, "Industrieviertel"],
  ["wolfsthal", "Wolfsthal", "niederoesterreich", "2412", 1_000, "Industrieviertel"],
  ["bad-deutsch-altenburg", "Bad Deutsch-Altenburg", "niederoesterreich", "2405", 1_700, "Industrieviertel"],
  ["enzersdorf-an-der-fischa", "Enzersdorf an der Fischa", "niederoesterreich", "2431", 2_700, "Industrieviertel"],
  ["margarethen-am-moos", "Margarethen am Moos", "niederoesterreich", "2433", 1_300, "Industrieviertel"],
  ["rauchenwarth", "Rauchenwarth", "niederoesterreich", "2320", 600, "Industrieviertel"],
  ["klein-neusiedl", "Klein-Neusiedl", "niederoesterreich", "2431", 600, "Industrieviertel"],
  ["zwoelfaxing", "Zwölfaxing", "niederoesterreich", "2320", 1_700, "Industrieviertel"],
  ["achau", "Achau", "niederoesterreich", "2481", 1_500, "Industrieviertel"],

  // ===== Burgenland – Nord (Neusiedlersee, Eisenstadt-Umland) =====
  ["eisenstadt", "Eisenstadt", "burgenland", "7000", 15_400, "Nordburgenland"],
  ["neusiedl-am-see", "Neusiedl am See", "burgenland", "7100", 9_800, "Nordburgenland"],
  ["mattersburg", "Mattersburg", "burgenland", "7210", 7_400, "Nordburgenland"],
  ["rust", "Rust", "burgenland", "7071", 1_900, "Nordburgenland"],
  ["frauenkirchen", "Frauenkirchen", "burgenland", "7132", 3_000, "Nordburgenland"],
  ["parndorf", "Parndorf", "burgenland", "7111", 4_900, "Nordburgenland"],
  ["bruckneudorf", "Bruckneudorf", "burgenland", "2460", 3_600, "Nordburgenland"],
  ["gols", "Gols", "burgenland", "7122", 3_900, "Nordburgenland"],
  ["moenchhof", "Mönchhof", "burgenland", "7123", 2_400, "Nordburgenland"],
  ["halbturn", "Halbturn", "burgenland", "7131", 2_000, "Nordburgenland"],
  ["andau", "Andau", "burgenland", "7163", 2_300, "Nordburgenland"],
  ["pamhagen", "Pamhagen", "burgenland", "7152", 1_900, "Nordburgenland"],
  ["apetlon", "Apetlon", "burgenland", "7143", 1_800, "Nordburgenland"],
  ["illmitz", "Illmitz", "burgenland", "7142", 2_500, "Nordburgenland"],
  ["podersdorf", "Podersdorf am See", "burgenland", "7141", 2_100, "Nordburgenland"],
  ["weiden-am-see", "Weiden am See", "burgenland", "7121", 2_400, "Nordburgenland"],
  ["gattendorf", "Gattendorf", "burgenland", "2474", 1_500, "Nordburgenland"],
  ["nickelsdorf", "Nickelsdorf", "burgenland", "2425", 1_800, "Nordburgenland"],
  ["zurndorf", "Zurndorf", "burgenland", "2424", 2_400, "Nordburgenland"],
  ["kittsee", "Kittsee", "burgenland", "2421", 3_400, "Nordburgenland"],
  ["pama", "Pama", "burgenland", "2422", 1_100, "Nordburgenland"],
  ["edelstal", "Edelstal", "burgenland", "2413", 900, "Nordburgenland"],
  ["deutsch-jahrndorf", "Deutsch Jahrndorf", "burgenland", "2423", 700, "Nordburgenland"],
  ["hornstein", "Hornstein", "burgenland", "7053", 3_200, "Nordburgenland"],
  ["muellendorf", "Müllendorf", "burgenland", "7052", 1_700, "Nordburgenland"],
  ["trausdorf", "Trausdorf an der Wulka", "burgenland", "7061", 1_300, "Nordburgenland"],
  ["grosshoeflein", "Großhöflein", "burgenland", "7051", 2_000, "Nordburgenland"],
  ["donnerskirchen", "Donnerskirchen", "burgenland", "7082", 1_800, "Nordburgenland"],
  ["purbach", "Purbach am Neusiedler See", "burgenland", "7083", 2_700, "Nordburgenland"],
  ["breitenbrunn", "Breitenbrunn", "burgenland", "7091", 1_900, "Nordburgenland"],
  ["winden", "Winden am See", "burgenland", "7092", 1_000, "Nordburgenland"],
  ["jois", "Jois", "burgenland", "7093", 1_500, "Nordburgenland"],
  ["schuetzen", "Schützen am Gebirge", "burgenland", "7081", 1_600, "Nordburgenland"],
  ["sankt-margarethen", "St. Margarethen im Burgenland", "burgenland", "7062", 2_700, "Nordburgenland"],
  ["moerbisch", "Mörbisch am See", "burgenland", "7072", 2_200, "Nordburgenland"],
  ["oggau", "Oggau am Neusiedler See", "burgenland", "7063", 1_800, "Nordburgenland"],
  ["poettsching", "Pöttsching", "burgenland", "7033", 3_400, "Nordburgenland"],
  ["wiesen", "Wiesen", "burgenland", "7203", 2_700, "Nordburgenland"],
  ["bad-sauerbrunn", "Bad Sauerbrunn", "burgenland", "7202", 1_700, "Nordburgenland"],
  ["forchtenstein", "Forchtenstein", "burgenland", "7212", 2_700, "Nordburgenland"],
  ["sigless", "Sigleß", "burgenland", "7032", 1_400, "Nordburgenland"],

  // Burgenland Mitte / Süd
  ["oberpullendorf", "Oberpullendorf", "burgenland", "7350", 4_100, "Mittelburgenland"],
  ["lockenhaus", "Lockenhaus", "burgenland", "7442", 2_000, "Mittelburgenland"],
  ["stoob", "Stoob", "burgenland", "7344", 1_500, "Mittelburgenland"],
  ["neckenmarkt", "Neckenmarkt", "burgenland", "7311", 1_900, "Mittelburgenland"],
  ["deutschkreutz", "Deutschkreutz", "burgenland", "7301", 3_300, "Mittelburgenland"],
  ["horitschon", "Horitschon", "burgenland", "7312", 1_900, "Mittelburgenland"],
  ["oberwart", "Oberwart", "burgenland", "7400", 7_900, "Südburgenland"],
  ["pinkafeld", "Pinkafeld", "burgenland", "7423", 5_600, "Südburgenland"],
  ["bad-tatzmannsdorf", "Bad Tatzmannsdorf", "burgenland", "7431", 1_400, "Südburgenland"],
  ["stadtschlaining", "Stadtschlaining", "burgenland", "7461", 1_900, "Südburgenland"],
  ["rechnitz", "Rechnitz", "burgenland", "7471", 3_000, "Südburgenland"],
  ["grosspetersdorf", "Großpetersdorf", "burgenland", "7503", 3_700, "Südburgenland"],
  ["markt-allhau", "Markt Allhau", "burgenland", "7411", 1_900, "Südburgenland"],
  ["guessing", "Güssing", "burgenland", "7540", 3_700, "Südburgenland"],
  ["stegersbach", "Stegersbach", "burgenland", "7551", 2_700, "Südburgenland"],
  ["jennersdorf", "Jennersdorf", "burgenland", "8380", 4_300, "Südburgenland"],
  ["mogersdorf", "Mogersdorf", "burgenland", "8382", 1_100, "Südburgenland"],
  ["heiligenkreuz-bgld", "Heiligenkreuz im Lafnitztal", "burgenland", "7561", 1_400, "Südburgenland"],

  // ===== Oberösterreich =====
  ["linz", "Linz", "oberoesterreich", "4020", 211_000, "Zentralraum"],
  ["wels", "Wels", "oberoesterreich", "4600", 63_500, "Hausruckviertel"],
  ["steyr", "Steyr", "oberoesterreich", "4400", 38_300, "Traunviertel"],
  ["leonding", "Leonding", "oberoesterreich", "4060", 29_700, "Zentralraum"],
  ["traun", "Traun", "oberoesterreich", "4050", 24_700, "Zentralraum"],
  ["braunau-am-inn", "Braunau am Inn", "oberoesterreich", "5280", 17_000, "Innviertel"],
  ["ansfelden", "Ansfelden", "oberoesterreich", "4052", 16_800, "Zentralraum"],
  ["bad-ischl", "Bad Ischl", "oberoesterreich", "4820", 14_100, "Salzkammergut"],
  ["voecklabruck", "Vöcklabruck", "oberoesterreich", "4840", 12_800, "Hausruckviertel"],
  ["marchtrenk", "Marchtrenk", "oberoesterreich", "4614", 14_300, "Hausruckviertel"],
  ["ried-im-innkreis", "Ried im Innkreis", "oberoesterreich", "4910", 11_900, "Innviertel"],
  ["enns", "Enns", "oberoesterreich", "4470", 12_000, "Traunviertel"],
  ["gmunden", "Gmunden", "oberoesterreich", "4810", 13_300, "Salzkammergut"],
  ["perg", "Perg", "oberoesterreich", "4320", 8_800, "Mühlviertel"],
  ["schaerding", "Schärding", "oberoesterreich", "4780", 5_200, "Innviertel"],
  ["freistadt", "Freistadt", "oberoesterreich", "4240", 7_700, "Mühlviertel"],
  ["mauthausen", "Mauthausen", "oberoesterreich", "4310", 5_200, "Mühlviertel"],
  ["eferding", "Eferding", "oberoesterreich", "4070", 4_400, "Hausruckviertel"],
  ["engerwitzdorf", "Engerwitzdorf", "oberoesterreich", "4209", 8_900, "Mühlviertel"],
  ["asten", "Asten", "oberoesterreich", "4481", 7_900, "Zentralraum"],
  ["pasching", "Pasching", "oberoesterreich", "4061", 7_700, "Zentralraum"],
  ["hoersching", "Hörsching", "oberoesterreich", "4063", 6_300, "Zentralraum"],
  ["sierning", "Sierning", "oberoesterreich", "4522", 9_300, "Traunviertel"],
  ["sankt-florian", "Sankt Florian", "oberoesterreich", "4490", 6_400, "Zentralraum"],
  ["sankt-valentin", "Sankt Valentin", "oberoesterreich", "4300", 9_400, "Traunviertel"],
  ["altmuenster", "Altmünster", "oberoesterreich", "4813", 9_900, "Salzkammergut"],
  ["vorchdorf", "Vorchdorf", "oberoesterreich", "4655", 7_400, "Traunviertel"],
  ["attnang-puchheim", "Attnang-Puchheim", "oberoesterreich", "4800", 9_300, "Hausruckviertel"],
  ["bad-hall", "Bad Hall", "oberoesterreich", "4540", 5_500, "Traunviertel"],
  ["kirchdorf-an-der-krems", "Kirchdorf an der Krems", "oberoesterreich", "4560", 4_500, "Traunviertel"],
  ["rohrbach", "Rohrbach-Berg", "oberoesterreich", "4150", 3_500, "Mühlviertel"],
  ["bad-leonfelden", "Bad Leonfelden", "oberoesterreich", "4190", 4_200, "Mühlviertel"],
  ["gallneukirchen", "Gallneukirchen", "oberoesterreich", "4210", 6_900, "Mühlviertel"],
  ["pregarten", "Pregarten", "oberoesterreich", "4230", 5_800, "Mühlviertel"],
  ["timelkam", "Timelkam", "oberoesterreich", "4850", 6_500, "Hausruckviertel"],
  ["lambach", "Lambach", "oberoesterreich", "4650", 3_500, "Hausruckviertel"],
  ["schwanenstadt", "Schwanenstadt", "oberoesterreich", "4690", 4_500, "Hausruckviertel"],
  ["frankenmarkt", "Frankenmarkt", "oberoesterreich", "4890", 3_700, "Hausruckviertel"],
  ["mattighofen", "Mattighofen", "oberoesterreich", "5230", 6_900, "Innviertel"],
  ["altheim", "Altheim", "oberoesterreich", "4950", 5_100, "Innviertel"],
  ["andorf", "Andorf", "oberoesterreich", "4770", 4_700, "Innviertel"],
  ["geinberg", "Geinberg", "oberoesterreich", "4943", 1_700, "Innviertel"],
  ["windischgarsten", "Windischgarsten", "oberoesterreich", "4580", 2_500, "Traunviertel"],

  // ===== Steiermark =====
  ["graz", "Graz", "steiermark", "8010", 300_000, "Landeshauptstadt"],
  ["leoben", "Leoben", "steiermark", "8700", 24_600, "Obersteiermark"],
  ["kapfenberg", "Kapfenberg", "steiermark", "8605", 22_900, "Obersteiermark"],
  ["bruck-an-der-mur", "Bruck an der Mur", "steiermark", "8600", 12_900, "Obersteiermark"],
  ["knittelfeld", "Knittelfeld", "steiermark", "8720", 12_700, "Obersteiermark"],
  ["koeflach", "Köflach", "steiermark", "8580", 9_900, "Weststeiermark"],
  ["voitsberg", "Voitsberg", "steiermark", "8570", 9_300, "Weststeiermark"],
  ["deutschlandsberg", "Deutschlandsberg", "steiermark", "8530", 11_400, "Südsteiermark"],
  ["feldbach", "Feldbach", "steiermark", "8330", 13_400, "Südoststeiermark"],
  ["hartberg", "Hartberg", "steiermark", "8230", 6_700, "Oststeiermark"],
  ["weiz", "Weiz", "steiermark", "8160", 11_800, "Oststeiermark"],
  ["fuerstenfeld", "Fürstenfeld", "steiermark", "8280", 8_900, "Oststeiermark"],
  ["liezen", "Liezen", "steiermark", "8940", 8_300, "Ennstal"],
  ["trofaiach", "Trofaiach", "steiermark", "8793", 10_900, "Obersteiermark"],
  ["muerzzuschlag", "Mürzzuschlag", "steiermark", "8680", 8_300, "Obersteiermark"],
  ["judenburg", "Judenburg", "steiermark", "8750", 9_900, "Murtal"],
  ["bad-aussee", "Bad Aussee", "steiermark", "8990", 4_700, "Ausseerland"],
  ["schladming", "Schladming", "steiermark", "8970", 6_800, "Ennstal"],
  ["gleisdorf", "Gleisdorf", "steiermark", "8200", 11_400, "Oststeiermark"],
  ["leibnitz", "Leibnitz", "steiermark", "8430", 12_700, "Südsteiermark"],
  ["seiersberg-pirka", "Seiersberg-Pirka", "steiermark", "8054", 11_800, "Graz-Umgebung"],
  ["radkersburg", "Bad Radkersburg", "steiermark", "8490", 3_100, "Südoststeiermark"],
  ["mariazell", "Mariazell", "steiermark", "8630", 3_700, "Obersteiermark"],
  ["eisenerz", "Eisenerz", "steiermark", "8790", 3_900, "Obersteiermark"],
  ["frohnleiten", "Frohnleiten", "steiermark", "8130", 6_900, "Graz-Umgebung"],
  ["leoben-donawitz", "Leoben-Donawitz", "steiermark", "8700", 5_000, "Obersteiermark"],

  // ===== Tirol =====
  ["innsbruck", "Innsbruck", "tirol", "6020", 132_000, "Landeshauptstadt"],
  ["kufstein", "Kufstein", "tirol", "6330", 19_700, "Unterland"],
  ["telfs", "Telfs", "tirol", "6410", 15_900, "Oberland"],
  ["schwaz", "Schwaz", "tirol", "6130", 13_900, "Unterland"],
  ["hall-in-tirol", "Hall in Tirol", "tirol", "6060", 14_500, "Inntal"],
  ["woergl", "Wörgl", "tirol", "6300", 14_400, "Unterland"],
  ["lienz", "Lienz", "tirol", "9900", 11_900, "Osttirol"],
  ["imst", "Imst", "tirol", "6460", 10_900, "Oberland"],
  ["rum", "Rum", "tirol", "6063", 9_300, "Inntal"],
  ["sankt-johann-in-tirol", "St. Johann in Tirol", "tirol", "6380", 9_400, "Unterland"],
  ["reutte", "Reutte", "tirol", "6600", 6_900, "Außerfern"],
  ["landeck", "Landeck", "tirol", "6500", 7_800, "Oberland"],
  ["zirl", "Zirl", "tirol", "6170", 8_400, "Inntal"],
  ["kitzbuehel", "Kitzbühel", "tirol", "6370", 8_400, "Unterland"],
  ["jenbach", "Jenbach", "tirol", "6200", 7_400, "Unterland"],
  ["mils", "Mils", "tirol", "6068", 4_700, "Inntal"],
  ["vomp", "Vomp", "tirol", "6134", 5_000, "Unterland"],

  // ===== Kärnten =====
  ["klagenfurt", "Klagenfurt am Wörthersee", "kaernten", "9020", 102_000, "Landeshauptstadt"],
  ["villach", "Villach", "kaernten", "9500", 64_000, "Unterkärnten"],
  ["wolfsberg", "Wolfsberg", "kaernten", "9400", 24_900, "Lavanttal"],
  ["spittal-an-der-drau", "Spittal an der Drau", "kaernten", "9800", 15_200, "Oberkärnten"],
  ["sankt-veit-an-der-glan", "Sankt Veit an der Glan", "kaernten", "9300", 12_500, "Mittelkärnten"],
  ["feldkirchen", "Feldkirchen in Kärnten", "kaernten", "9560", 14_400, "Mittelkärnten"],
  ["voelkermarkt", "Völkermarkt", "kaernten", "9100", 11_000, "Unterkärnten"],
  ["hermagor", "Hermagor-Pressegger See", "kaernten", "9620", 6_900, "Gailtal"],
  ["wernberg", "Wernberg", "kaernten", "9241", 5_500, "Unterkärnten"],
  ["ferlach", "Ferlach", "kaernten", "9170", 7_300, "Unterkärnten"],
  ["althofen", "Althofen", "kaernten", "9330", 4_900, "Mittelkärnten"],
  ["friesach", "Friesach", "kaernten", "9360", 5_100, "Mittelkärnten"],

  // ===== Salzburg =====
  ["salzburg", "Salzburg (Stadt)", "salzburg-land", "5020", 156_000, "Landeshauptstadt"],
  ["hallein", "Hallein", "salzburg-land", "5400", 21_700, "Tennengau"],
  ["saalfelden", "Saalfelden am Steinernen Meer", "salzburg-land", "5760", 17_100, "Pinzgau"],
  ["sankt-johann-im-pongau", "Sankt Johann im Pongau", "salzburg-land", "5600", 11_400, "Pongau"],
  ["bischofshofen", "Bischofshofen", "salzburg-land", "5500", 10_500, "Pongau"],
  ["seekirchen-am-wallersee", "Seekirchen am Wallersee", "salzburg-land", "5201", 10_500, "Flachgau"],
  ["neumarkt-am-wallersee", "Neumarkt am Wallersee", "salzburg-land", "5202", 6_700, "Flachgau"],
  ["wals-siezenheim", "Wals-Siezenheim", "salzburg-land", "5071", 14_100, "Flachgau"],
  ["mittersill", "Mittersill", "salzburg-land", "5730", 5_700, "Pinzgau"],
  ["zell-am-see", "Zell am See", "salzburg-land", "5700", 10_000, "Pinzgau"],

  // ===== Vorarlberg =====
  ["bregenz", "Bregenz", "vorarlberg", "6900", 30_000, "Landeshauptstadt"],
  ["dornbirn", "Dornbirn", "vorarlberg", "6850", 51_000, "Rheintal"],
  ["feldkirch", "Feldkirch", "vorarlberg", "6800", 35_000, "Vorderland"],
  ["lustenau", "Lustenau", "vorarlberg", "6890", 24_500, "Rheintal"],
  ["hohenems", "Hohenems", "vorarlberg", "6845", 17_000, "Rheintal"],
  ["bludenz", "Bludenz", "vorarlberg", "6700", 14_900, "Walgau"],
  ["hard", "Hard", "vorarlberg", "6971", 14_500, "Rheintal"],
  ["rankweil", "Rankweil", "vorarlberg", "6830", 12_400, "Vorderland"],
  ["goetzis", "Götzis", "vorarlberg", "6840", 11_900, "Rheintal"],
  ["wolfurt", "Wolfurt", "vorarlberg", "6922", 8_900, "Rheintal"],
  ["lauterach", "Lauterach", "vorarlberg", "6923", 10_800, "Rheintal"],
  ["hoechst", "Höchst", "vorarlberg", "6973", 8_400, "Rheintal"],
  ["nenzing", "Nenzing", "vorarlberg", "6710", 6_500, "Walgau"],
];

export const staedte: Location[] = compact.map(([slug, name, bs, plz, pop, region]) => ({
  slug,
  name,
  type: "stadt",
  bundesland:
    bundeslaender.find((b) => b.bundeslandSlug === bs)?.name ?? bs,
  bundeslandSlug: bs,
  plz,
  population: pop,
  region,
}));

export const allLocations: Location[] = [...bundeslaender, ...staedte, ...wienBezirke];

export const locationBySlug = Object.fromEntries(
  allLocations.map((l) => [l.slug, l]),
) as Record<string, Location>;

export function locationsByBundesland(bundeslandSlug: string): Location[] {
  return staedte.filter((l) => l.bundeslandSlug === bundeslandSlug);
}
